import { render, staticRenderFns } from "./LiveChat.vue?vue&type=template&id=f6278486"
import script from "./LiveChat.vue?vue&type=script&lang=js"
export * from "./LiveChat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports